import { render } from "./MessageModal.vue?vue&type=template&id=80aa3a54&scoped=true&ts=true"
import script from "./MessageModal.vue?vue&type=script&lang=ts"
export * from "./MessageModal.vue?vue&type=script&lang=ts"

import "./MessageModal.vue?vue&type=style&index=0&id=80aa3a54&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80aa3a54"]])

export default __exports__